// src/project/data/fetches/kyc.js
import { buildUrlWithAuth, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'

export default {
  url() {
    const userId = getUserId()
    // Le kycId rider est toujours déterministe : kyc_rider_{userId}
    const kycId = `kyc_rider_${userId}`
    return buildUrlWithAuth(RIDER_ENDPOINTS.KYC_DETAILS(kycId))
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "KYC found", data: { id, userId, status, data: { personalInfo, identityDocument, vehicleDocument, selfieUrl }, metadata: { status, submittedAt, ... } } }
    if (raw?.statusCode === 404) {
      return { statusCode: 200, data: { status: 'not_filled', kycData: null, statusData: null } }
    }
    if (raw?.statusCode !== 200) {
      return { statusCode: raw?.statusCode || 500, data: { status: 'error', kycData: null, statusData: null } }
    }

    const kycData = raw?.data || {}
    const metadata = kycData.metadata || {}
    const statusField = metadata.status || kycData.status

    let appStatus = 'not_filled'
    switch (statusField) {
      case 'not_started':
      case 'not_submitted':
        appStatus = 'not_filled'
        break
      case 'pending':
      case 'submitted':
        appStatus = 'pending'
        break
      case 'approved':
      case 'verified':
        appStatus = 'validated'
        break
      case 'rejected':
        appStatus = 'rejected'
        break
      default:
        appStatus = 'not_filled'
    }

    return {
      statusCode: 200,
      data: {
        status: appStatus,
        kycData: kycData.data || null,
        statusData: {
          rejectionReason: metadata.rejectionReason,
          submittedAt: metadata.submittedAt,
          verifiedAt: metadata.verifiedAt,
          documentsStatus: metadata.documentsStatus,
          nextAction: metadata.nextAction,
          completedSteps: metadata.completedSteps,
          requiredSteps: metadata.requiredSteps,
        },
      },
    }
  },
}
